import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Row,
  Layout,
  Form,
  Input,
  Radio,
  DatePicker,
} from "antd";
import { useNavigate } from "react-router";
import { CloseCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Post } from "../../config/api/post";
import { COACH } from "../../config/constants/api";
import { addUser } from "../../redux/slice/authSlice";
import swal from "sweetalert";
import dayjs from "dayjs";
import { FaArrowLeft } from "react-icons/fa";
import "../profile/profile.css";
import "./education.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

function Education() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [editMode, setEditMode] = useState(false);

  React.useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const onFinish = (values) => {
    Post(COACH.updateProfile, values, token, null)
      .then((response) => {
        if (response?.data?.status) {
          dispatch(addUser({ user: response.data.data, token: token }));
          swal("Success!", "Education Updated Successfully", "success");
          setEditMode(false);
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch(() => {});
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const educationList = user?.education || [];

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <button
            type="button"
            className="education-back"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FaArrowLeft />
            Back
          </button>
          <h1 className="fontFamily1 profile-hero-title">Education</h1>
          <p className="fontFamily1 profile-hero-sub">
            Manage your institutions, dates, subjects, and diploma details.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/education" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">
                  Education Details
                </h2>
                <p className="profile-panel-sub">
                  {editMode
                    ? "Add or update your educational background."
                    : "Your saved education history."}
                </p>
              </div>
            </div>

            <Form
              layout="vertical"
              name="basic"
              className="contactForm profile-form"
              labelCol={{ span: 0 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              {editMode ? (
                <>
                  <Form.List
                    name="education"
                    initialValue={educationList.map((item) => ({
                      ...item,
                      start: dayjs(item.start),
                      end: dayjs(item.end),
                      subject: Array.isArray(item.subject)
                        ? item.subject.join(",")
                        : item.subject,
                    }))}
                  >
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <div key={key} className="education-block">
                            <div className="education-block-head">
                              <h3 className="education-block-title">
                                Education {index + 1}
                              </h3>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="education-remove"
                                  onClick={() => remove(name)}
                                  aria-label="Remove education entry"
                                >
                                  <CloseCircleOutlined />
                                </button>
                              )}
                            </div>

                            <Row gutter={20}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  {...restField}
                                  label="Institution Name*"
                                  name={[name, "school"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter institution name ",
                                    },
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    placeholder="Enter institution name"
                                    className="signupFormInput"
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  {...restField}
                                  label="Start Date*"
                                  name={[name, "start"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter start date ",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    style={{ width: "100%" }}
                                    size="large"
                                    picker="month"
                                    placeholder="enter start date"
                                    className="signupFormInput"
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  {...restField}
                                  label="End Date*"
                                  name={[name, "end"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter end date ",
                                    },
                                  ]}
                                >
                                  <DatePicker
                                    style={{ width: "100%" }}
                                    size="large"
                                    picker="month"
                                    placeholder="enter end date"
                                    className="signupFormInput"
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  {...restField}
                                  label="Subject Studied*"
                                  name={[name, "subject"]}
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Please enter coma seperated subjects",
                                    },
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    placeholder="Enter subject Studied (coma seperated)"
                                    className="signupFormInput"
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  {...restField}
                                  label="Diploma Earned*"
                                  name={[name, "isDiploma"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select one ",
                                    },
                                  ]}
                                >
                                  <Radio.Group>
                                    <Radio value={true}>
                                      <span
                                        className="fontFamily1"
                                        style={{ color: "grey" }}
                                      >
                                        Yes
                                      </span>
                                    </Radio>
                                    <Radio value={false}>
                                      <span
                                        className="fontFamily1"
                                        style={{ color: "grey" }}
                                      >
                                        No
                                      </span>
                                    </Radio>
                                  </Radio.Group>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        ))}
                        <Form.Item>
                          <Button
                            type="dashed"
                            size="large"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                            className="education-add-btn"
                          >
                            Add Educational Details
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <div className="profile-actions">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="profile-btn-primary"
                    >
                      Save
                    </Button>
                    <Button
                      className="profile-btn-ghost"
                      ghost
                      size="large"
                      onClick={(e) => {
                        e.preventDefault();
                        setEditMode(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  {educationList.length === 0 ? (
                    <p className="education-empty">
                      No education details added yet.
                    </p>
                  ) : (
                    educationList.map((item, index) => (
                      <div key={`edu-view-${index}`} className="education-block">
                        <h3 className="education-block-title">
                          Education {index + 1}
                        </h3>
                        <div className="profile-fields">
                          <div className="profile-field">
                            <p className="profile-field-label">School Name</p>
                            <p className="profile-field-value">
                              {item?.school || "—"}
                            </p>
                          </div>
                          <div className="profile-field">
                            <p className="profile-field-label">Start Date</p>
                            <p className="profile-field-value">
                              {item?.start
                                ? dayjs(item.start).format("MMMM - YYYY")
                                : "—"}
                            </p>
                          </div>
                          <div className="profile-field">
                            <p className="profile-field-label">End Date</p>
                            <p className="profile-field-value">
                              {item?.end
                                ? dayjs(item.end).format("MMMM - YYYY")
                                : "—"}
                            </p>
                          </div>
                          <div className="profile-field">
                            <p className="profile-field-label">Diploma Earned</p>
                            <p className="profile-field-value">
                              {item?.isDiploma ? "Yes" : "No"}
                            </p>
                          </div>
                          <div className="profile-field profile-field--wide">
                            <p className="profile-field-label">
                              Subject Studied
                            </p>
                            <p className="profile-field-value">
                              {Array.isArray(item?.subject)
                                ? item.subject.join(",")
                                : item?.subject || "—"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </>
              )}
            </Form>

            {!editMode && (
              <div className="profile-actions">
                <Button
                  type="primary"
                  htmlType="button"
                  className="profile-btn-primary"
                  onClick={() => setEditMode(true)}
                >
                  Update Education
                </Button>
              </div>
            )}
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Education;
